import api from "./axios";

// Suggestion types enum
export enum SuggestionType {
  INITIALIZE = 'Initialize',
  FREQUENT = 'Frequent'
}

// Suggestion status enum
export enum SuggestionStatus {
  PROCESSING = 'Processing',
  COMPLETED = 'Completed'
}

// Suggestion types
export interface Suggestion {
  id: string;
  agent_id: string;
  suggestion_content: string;
  type: SuggestionType;
  created_at: string;
  updated_at: string;
}

export interface CreateSuggestionRequest {
  suggestion_content: string;
  type: SuggestionType;
}

export interface UpdateSuggestionRequest {
  suggestion_content: string;
  type: SuggestionType;
}

export interface SuggestionsListParams {
  type?: SuggestionType;
}

export interface SuggestionsListResponse {
  suggestions: Suggestion[];
  status: SuggestionStatus;
}

// Suggestions API
export const suggestionsApi = {
  // Get list of suggestions for a specific agent with filtering and pagination
  getList: async (agentId: string, params: SuggestionsListParams): Promise<SuggestionsListResponse> => {
    const response = await api.get(`/agents/${agentId}/suggestions/search`, { params });
    return response.data;
  },

  // Create new suggestion for a specific agent
  create: async (agentId: string, data: CreateSuggestionRequest): Promise<Suggestion> => {
    const response = await api.post(`/agents/${agentId}/suggestions`, data);
    return response.data;
  },

  // Update suggestion
  update: async (agentId: string, suggestionId: string, data: UpdateSuggestionRequest): Promise<Suggestion> => {
    const response = await api.put(`/agents/${agentId}/suggestions/${suggestionId}`, data);
    return response.data;
  },

  // Delete suggestion
  delete: async (agentId: string, suggestionId: string): Promise<void> => {
    await api.delete(`/agents/${agentId}/suggestions/${suggestionId}`);
  },

  // Regenerate suggestions for a specific agent
  regenerate: async (agentId: string): Promise<void> => {
    await api.post(`/agents/${agentId}/suggestions/regenerate`);
  },
};
